import TRP from '../Shared/TRP/TRP';
export const TransferConstant = {
  labels: {
    TRANSFER: 'TRANSFER',
  },
  existingAccountTypes: [
    'ROTH_IRA',
    'ROLLOVER_IRA',
    'TRADITIONAL_IRA',
    'INDIVIDUAL',
    'JOINT_TENANT',
    'UGMA_UTMA',
  ],
  accountDeatilPage: {
    trowePrice: <TRP />,
    label: 'Provide transfer account details',
    stepperLabel: 'Provide account details',
    firmNameValue: 'T. Rowe Price',
    desc1:
      'Make sure the following information matches what appears on your account statements from your external financial institution.',
    transferTo: ' Transfer To:',
    firmName: 'Firm Name',
    accountType: ' Account Type',
    accountNumber: ' Account Number',
    transferFrom: ' Transfer From :',
    financialInstitution: 'Financial Institution',
    institutionName: 'External Financial Institution Name',
    institutionNameDesc:
      'Find and select your institution. If yours is not listed, you can add it manually by typing the firm’s full name.',
    dontSeeMsg: 'Don’t see your institution listed?',
    addMannually: 'Add Manually',
    financialAccountNumber: 'External Financial Institution Account Number',
    financialAccountNumberDesc:
      'Check your most recent statement for the account holding the assets you wish to transfer.',
    transferCertificateRadio:
      ' Are you transferring Certificates of Deposit (CDs) held at a bank or credit union?',
    transferCertificateDesc:
      ' These kinds of certificates of deposit are not transferred  “in-kind” and will be liquidated and transferred as cash.',
    Yes: 'Yes',
    No: 'No (most common)',
  },
  transferAmountPage: {
    label: 'Enter transfer amount',
    heading: 'Provide Certificate of Deposit (CD) details',
    description:
      'Certificates of Deposit (CDs), commonly held at banks and credit unions, do not transfer “in-kind” and must be liquidated to cash.',
    transferHeader: 'Transfer Instructions',
    transferDesc:
      'You can transfer everything or select specific assets held in your account.',
    fullTransferLabel: 'Transfer the entire account (most common)',
    partialTransferLabel: 'Partial transfer',
    timeFrameHeader: 'Liquidation Time Frame',
    timeFrameDesc:
      'Choose when you would like to liquidate your CDs prior to transfer.',
    earlyWithdrawLabel:
      'Immediately (I agree to pay any early withdrawal fees)',
    maturityLabel: 'Upon maturity',
    maturityDateHeader: 'Certificate of Deposit (CD) Maturity Date',
    maturityDesc:
      'In order to transfer at the maturity date, this form must be received within 15-30 days of maturity.',
    partialText: 'Dollar Value of Bank CD Assets to Transfer',
    checkBoxTitle: 'AllCash',
    continueButton: 'Continue',
  },
  transferReviewPage: {
    title: 'Brokergage Transfer Setup',
    description: 'Transfer review Page',
    label: 'Review your transfer',
    fundingMethodType: 'External Asset Transfer',
  },
  nextStepsPage: {
    headerTitle: 'Sign and mail your transfer form',
    pageDesc:
      'T. Rowe Price can initiate your transfer once we’ve received some critical documents.',
    stepTitle1: 'Download, print and sign the brokerage transfer form:',
    stepTitle2: `Print your latest <account type> statement from`,
    stepTitle3: 'Mail all signed documents and statements to:',
    noteTitle: "What's next?",
    noteText:
      'Once we receive all the documents and statements, it may take up to 7-10 business days to process your transfer. We will reach out to you if any additional documents are needed.',
  },
  transferFunding: {
    link: {
      trpevents:
        'https://trpii-events.secure.force.com/cts?Id=BmHUJ3.r_II7SPf0tLqOApLsP2c0vU0jI_CtZ5TM1c8-',
    },
  },
};
